/* ══════════════════════════════════════════════════════════════════
   bf-cards — slider da seção nativa
   ------------------------------------------------------------------
   Só cuida de setas + bolinhas. NÃO busca produto, NÃO procura o DOM:
   os cards já vêm renderizados pelo Liquid no HTML.

   Diferenças vs o motor antigo (bf-cards-motor-v2):
     - sem setInterval (o antigo rodava 300ms x 66 = 19,8s)
     - sem MutationObserver (o antigo observava o documento por 20s)
     - sem fetch /products/*.js (o antigo fazia 16 por página)
     - offsets medidos 1x e cacheados (o antigo lia offsetLeft em loop
       a cada evento de scroll -> forced reflow)
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  function initCarousel(root) {
    if (root.dataset.bfReady === '1') return;
    root.dataset.bfReady = '1';

    var rail = root.querySelector('.bf-cards__rail');
    var dots = root.querySelector('.bf-cards__dots');
    var prev = root.querySelector('.bf-cards__nav.prev');
    var next = root.querySelector('.bf-cards__nav.next');
    if (!rail) return;

    var cards = Array.prototype.slice.call(rail.querySelectorAll('.pcard'));
    if (!cards.length) return;

    var offsets = [];
    var maxScroll = 0;

    /* uma única batelada de leitura de layout */
    function measure() {
      var railLeft = rail.offsetLeft;
      offsets = cards.map(function (c) { return c.offsetLeft - railLeft; });
      maxScroll = rail.scrollWidth - rail.clientWidth - 2;
    }

    if (dots) {
      dots.innerHTML = '';
      cards.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', 'Produto ' + (i + 1));
        b.addEventListener('click', function () {
          rail.scrollTo({ left: offsets[i], behavior: 'smooth' });
        });
        dots.appendChild(b);
      });
    }

    function activeIdx(sl) {
      var best = 0, bd = Infinity;
      for (var i = 0; i < offsets.length; i++) {
        var dd = Math.abs(offsets[i] - sl);
        if (dd < bd) { bd = dd; best = i; }
      }
      return best;
    }

    function update() {
      var sl = rail.scrollLeft;
      var idx = activeIdx(sl);
      if (dots) {
        for (var i = 0; i < dots.children.length; i++) {
          dots.children[i].setAttribute('aria-selected', i === idx ? 'true' : 'false');
        }
      }
      if (prev) prev.disabled = sl <= 2;
      if (next) next.disabled = sl >= maxScroll;
    }

    if (prev) prev.addEventListener('click', function () {
      rail.scrollBy({ left: -Math.round(rail.clientWidth * 0.9), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      rail.scrollBy({ left: Math.round(rail.clientWidth * 0.9), behavior: 'smooth' });
    });

    var ticking = false;
    rail.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { update(); ticking = false; });
    }, { passive: true });

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { measure(); update(); }, 150);
    });

    measure();
    update();
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-bf-cards]');
    for (var i = 0; i < roots.length; i++) initCarousel(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* re-inicializa quando o Editor de Tema recarrega a seção */
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
}());
